module.exports = __webpack_public_path__ + "img/holidays.491a4895.svg";